import axios from 'axios'
const FormApi = window.env.VUE_APP_FORM_OPEN
function getAxios() {
    return axios.create({
        baseURL: window.env.VUE_APP_API || '/api',
        timeout: 150000
    })
}
const axiosInstance = getAxios()
axiosInstance.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        return error
    }
)
export { FormApi, axiosInstance as axios }
